import request from "@/utils/request";

export function getAllPollenBottleTransactionType() {
    return request({
        url: "/api/services/app/PollenBottleTransaction/GetAllTypesForDropDown",
        method: "GET"
    });
}

export function createTransaction(data) {
    return request({
        url: "/api/services/app/PollenBottleTransaction/Create",
        method: "POST",
        data
    });
}

export function createManyTransaction(data) {
    return request({
        url: "/api/services/app/PollenBottleTransaction/CreateMany",
        method: "POST",
        data
    });
}

export function updateTransaction(data) {
    return request({
        url: "/api/services/app/PollenBottleTransaction/Update",
        method: "PUT",
        data
    });
}

export function deleteTransaction(params) {
    return request({
        url: "/api/services/app/PollenBottleTransaction/Delete",
        method: "DELETE",
        params
    });
}

export function deleteManyTransaction(data) {
    return request({
        url: "/api/services/app/PollenBottleTransaction/DeleteMany",
        method: "POST",
        data
    });
}

export function getFilterInfo(params) {
    return request({
        url: "/api/services/app/PollenBottleTransaction/GetFilterInfo",
        method: "GET",
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/pollen_bottle_transaction.js